// extracted by mini-css-extract-plugin
module.exports = {"maintenance-section":"Maintenance_maintenance-section__px1mN","top-text":"Maintenance_top-text__sCjRZ","bottom-text":"Maintenance_bottom-text__SXNQl"};